import React from 'react';
import { Phone } from 'lucide-react';
import { translations } from '../utils/translations';
interface FloatingPhoneProps {
  lang: string;
}
export function FloatingPhone({
  lang
}: FloatingPhoneProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  return <a href="tel:+17862232564" className="fixed top-4 right-4 z-50 flex items-center justify-center w-14 h-14 bg-brand-red text-white rounded-full shadow-lg hover:bg-brand-darkred transition-colors animate-pulse-fast" aria-label={t.callNowLabel} data-id="element-43">
      <Phone className="w-6 h-6 fill-current" data-id="element-44" />
    </a>;
}